import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface CallChangesState {
    live: boolean;
}

const initialState: CallChangesState = {
    live: false,
};

const callChangesSlice = createSlice({
    name: 'callChanges',
    initialState,
    reducers: {
        setCallChangesLive: (state, action: PayloadAction<boolean>) => {
            state.live = action.payload;
        },
    },
});

export const {setCallChangesLive} = callChangesSlice.actions;

export const selectCallChangesLive = (state: { callChanges: CallChangesState }) => state.callChanges.live;

export default callChangesSlice.reducer;
